import { render } from "./AddSecteurActiviteModal.vue?vue&type=template&id=563f7dc0&ts=true"
import script from "./AddSecteurActiviteModal.vue?vue&type=script&lang=ts"
export * from "./AddSecteurActiviteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__